import React from "react";
import { RotaButtonNew } from "@teamrota/rota-design";
import BookingItem from "./BookingItem";
import { EmptyBookings, LoadMoreWrapper } from "./member-shift-list.styles";

const BookingList = ({
  items,
  activeTab,
  isTimesheetTab,
  shouldDisableLoadMore,
  onStateChange,
  onOpenBookingModal,
  onOpenShiftModal,
  onLoadMore
}) => {
  if (!items?.length) {
    return <EmptyBookings>No bookings</EmptyBookings>;
  }

  return (
    <>
      {items.map((item, index) => (
        <BookingItem
          key={index}
          booking={item}
          activeTab={activeTab}
          isTimesheetTab={isTimesheetTab}
          onStateChange={onStateChange}
          onOpenBookingModal={onOpenBookingModal}
          onOpenShiftModal={onOpenShiftModal}
        />
      ))}
      {!shouldDisableLoadMore && (
        <LoadMoreWrapper>
          <RotaButtonNew onClick={onLoadMore}>Load more</RotaButtonNew>
        </LoadMoreWrapper>
      )}
    </>
  );
};

export default BookingList;
